import { Navigate, Route, Routes } from 'react-router';
import { ActivityPage } from '@/pages/ActivityPage';
import { AdminsPage } from '@/pages/AdminsPage';
import { AISettingsPage } from '@/pages/AISettingsPage';
import { AppealsPage } from '@/pages/AppealsPage';
import { BansPage } from '@/pages/BansPage';
import { KnowledgeBasePage } from '@/pages/KnowledgeBasePage';
// Pages
import { LoginPage } from '@/pages/LoginPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { SubmissionsPage } from '@/pages/SubmissionsPage';
import { useAuthStore } from '@/stores/authStore';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const admin = useAuthStore((s) => s.admin);
  const isAdmin = admin?.role === 'owner' || admin?.role === 'admin';

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/:token" element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <OverviewPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/submissions"
        element={
          <PrivateRoute>
            <SubmissionsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/bans"
        element={
          <PrivateRoute>
            <BansPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/appeals"
        element={
          <PrivateRoute>
            <AppealsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/activity"
        element={
          <PrivateRoute>
            <ActivityPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/knowledge-base"
        element={
          <PrivateRoute>
            <KnowledgeBasePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/ai-settings"
        element={
          <PrivateRoute>
            <AISettingsPage />
          </PrivateRoute>
        }
      />

      {/* Admin-only routes */}
      <Route
        path="/admins"
        element={
          <PrivateRoute>
            <AdminRoute>
              <AdminsPage />
            </AdminRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <AdminRoute>
              <SettingsPage />
            </AdminRoute>
          </PrivateRoute>
        }
      />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
